import { render, staticRenderFns } from "./CourseUsers.vue?vue&type=template&id=05b2e03a&scoped=true"
import script from "./CourseUsers.vue?vue&type=script&lang=js"
export * from "./CourseUsers.vue?vue&type=script&lang=js"
import style0 from "./CourseUsers.vue?vue&type=style&index=0&id=05b2e03a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b2e03a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b2e03a')) {
      api.createRecord('05b2e03a', component.options)
    } else {
      api.reload('05b2e03a', component.options)
    }
    module.hot.accept("./CourseUsers.vue?vue&type=template&id=05b2e03a&scoped=true", function () {
      api.rerender('05b2e03a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CourseUsers.vue"
export default component.exports